export default function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
// module id = 1089
// module chunks = 0